import '../styles/Spinner.scss';

const Spinner = () => {
  return (
    <>
      <div className="loadership_EDGSW">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default Spinner;
